import React from 'react';

const LiffLoading = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-green-200 border-t-green-500 rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-500 text-sm">กำลังเชื่อมต่อ...</p>
      </div>
    </div>
  );
};

export default LiffLoading;
